export default "__VITE_ASSET__BKnaWZtj__"